import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../../features/user/userSlice';
import { toast } from '../../components/Common/Toast';
import { Navbar, Nav, Container, Dropdown } from 'react-bootstrap';
import { getSocket, disconnectSocket } from "../../utils/socket";
import config from "../../config";
const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Get user info directly from Redux store
  const { userInfo } = useSelector(state => state.user);
  const isLoggedIn = !!userInfo;
const handleLogout = async () => {
  try {
    const token = userInfo?.token || localStorage.getItem("token");

    if (token) {
      await fetch(`${config.baseURL}/api/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    }
  } catch (error) {
    console.error("Logout API failed:", error);
  } finally {
    // local cleanup
    disconnectSocket();
    dispatch(clearUser());
    localStorage.removeItem("token");
    // setShowProfile(false);
    navigate("/");
    toast.success("Logged out successfully!");
  }
};



  const handleNavToggle = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  // Enhanced CustomToggle with arrow indicators
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <button
        className="user-menu-button nav-link dropdown-toggle"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
          onClick(e);
        }}
      >
        <span className="user-greeting">
          {children}
          <span className="dropdown-arrow ms-1">
            {isOpen ? "▲" : "▼"}
          </span>
        </span>
      </button>
    );
  });

  return (
    <section className="header mainheader">
      <Navbar expand="lg" className="navbar">
        <Container>
          <Link className="navbar-brand" to="/">
            <img src="images/helix-logo.png" alt="Site Logo" />
          </Link>

          <Navbar.Toggle
            aria-controls="navbarSupportedContent"
            onClick={handleNavToggle}
          >
            <span className="navbar-toggler-icon" />
          </Navbar.Toggle>

          <Navbar.Collapse id="navbarSupportedContent" className={!isNavCollapsed ? 'show' : ''}>
            <Nav className="ms-auto mb-2 mb-lg-0">
              <Nav.Item>
                <Link className="nav-link active" aria-current="page" to="#">
                  About Us
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link className="nav-link active" to="#">
                  Help
                </Link>
              </Nav.Item>

              {isLoggedIn ? (
                <Dropdown as={Nav.Item}>
                  <Dropdown.Toggle as={CustomToggle}>
                    Hi, {userInfo?.first_name || "User"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate("/dashboard", { state: { activtab: "dash" } })}>
                      Dashboard
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => navigate("/dashboard", { state: { activtab: "settings" } })}>
                      Setting
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <Nav.Item>
                  <Link to="/login">
                    <button className="btn btn-filled ms-4" type="button">
                      <img src="images/login-arrow.svg" className="me-1" alt="Login" />
                      Login
                    </button>
                  </Link>
                </Nav.Item>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </section>
  );
};

export default Header;